const prefix = 'validateLinkReducer';

export const FETCH_VALIDATE_LINK = `${prefix}/FETCH_VALIDATE_LINK`;
export const FETCH_VALIDATE_LINK_SUCCESS = `${prefix}/FETCH_VALIDATE_LINK_SUCCESS`;
export const FETCH_VALIDATE_LINK_FAILURE = `${prefix}/FETCH_VALIDATE_LINK_FAILURE`;
export const ENTITLEMENT_SERVICE_API_ENDPOINT = '';
